import _extends from '@babel/runtime/helpers/extends';
import { makeStyles, LayoutGrid, ContextualMenuPopper } from '@archer-technologies/ui-components';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { createElement } from 'react';
var useStyles = makeStyles(function () {
  return {
    checkCellStyles: {
      margin: '-7px 0'
    }
  };
});

var ActionsFormatter = function ActionsFormatter(_ref) {
  var value = _ref.value;

  var _useStyles = useStyles(),
      checkCellStyles = _useStyles.checkCellStyles;

  return value ? /*#__PURE__*/createElement(LayoutGrid, {
    className: checkCellStyles
  }, /*#__PURE__*/createElement(ContextualMenuPopper, value)) : null;
};

var ActionTypeProvider = function ActionTypeProvider(props) {
  return /*#__PURE__*/createElement(DataTypeProvider, _extends({
    formatterComponent: ActionsFormatter
  }, props));
};

export { ActionTypeProvider, ActionsFormatter };